import { INTEGRATION_CONFIG_KEYS } from '@onward-delivery/core';
import { INTEGRATION_CONFIG_FIELDS } from '@/components/CorporateUsers/modals/constants';

// Same rule IntegrationRow's type select applies to a default; a type without fields can't be entered here.
export const TMS_TYPES = Object.keys(INTEGRATION_CONFIG_FIELDS).filter(
    (type) => INTEGRATION_CONFIG_KEYS[type]?.selectable
);

// integration_overrides_status_check allows exactly these.
const TMS_STATUSES = {
    PENDING: { label: 'Waiting for first sync', variant: 'warning' },
    NEEDS_INFO: { label: 'Needs info', variant: 'warning' },
    COMPLETE: { label: 'Connected', variant: 'primary' },
    ERROR: { label: 'Error', variant: 'destructive' },
};

export const tmsStatusOf = (status) => {
    if (!status) return null;

    const tmsStatus = TMS_STATUSES[status];
    if (!tmsStatus) throw new Error(`Unknown integration status ${status}`);

    return tmsStatus;
};

export const tmsMethodOf = (integration) => {
    if (integration.rec_isa_id || integration.send_isa_id) return 'EDI';
    if (integration.poll) return 'Polling';

    return 'API';
};

// The save endpoint rejects a config missing any of these, so they are what the card asks for.
export const requiredFieldLabelsOf = (type) => {
    const { required } = INTEGRATION_CONFIG_KEYS[type];
    const fields = INTEGRATION_CONFIG_FIELDS[type];

    return required.map((key) => {
        const field = fields.find((candidate) => candidate.key === key);
        if (!field) throw new Error(`${type} requires ${key}, which has no form field`);

        return field.label;
    });
};
